import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import logo from '../assets/img/logo.png';
import { getuser } from '../helpers/user.helper';
import './Login.css';
import { login } from '../services/user.service';
import { toast } from 'react-toastify';
import formatString from "format-string-by-pattern";
import jQuery from 'jquery';

window.$ = jQuery;


export default function Login() {

    useEffect(() => {
        document.addEventListener('keypress', async function (e) {
            if (e.which == 13) {
                await handleOnclick();
            }
        }, false);
    }, [])

    let navigate = useNavigate();
    const [user, setUser] = useState(undefined);
    const [pass, setPass] = useState(undefined);
    const [isLoader, setIsloader] = useState(false);

    const userHandleChange = (value) => {
        let formatCpf = formatString('000.000.000-00', value);
        setUser(formatCpf);
    }

    const passHandleChange = (value) => {
        setPass(value);
    }

    const handleOnclick = async () => {
        setIsloader(true);
        let result = await login({ password: document.getElementById('pass')?.value, username: document.getElementById('user')?.value });
        if (result && result.status === 200) {
            localStorage.setItem('hondixTk', result.data.token);
            if (getuser().type !== "A")
                navigate('/vendas');
            else
                navigate('/app');
        }
        else {
            toast.warning('Usuário ou senha inválidos!');
        }
        setIsloader(false);
    }

    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-light fixed-top py-3" id="mainNav">
                <div className="container">
                    <a className="navbar-brand js-scroll-trigger" href="/"><img src={logo} width="100" height="100" alt="Hondix" /></a>
                    <button className="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon" />
                    </button>
                    <div className="collapse navbar-collapse" id="navbarResponsive">

                    </div>
                </div>
            </nav>
            <div className="simple-login-container">
                <h2>Entrar</h2>
                <div className="row">
                    <div className="col-md-12 form-group">
                        <input type="text" className="form-control" value={user} id="user" placeholder="Usuário" required onChange={(e) => userHandleChange(e.target.value)} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 form-group">
                        <input type="password" placeholder="Senha" value={pass} id="pass" className="form-control" required onChange={(e) => passHandleChange(e.target.value)} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 form-group">
                        <button type="submit" className="btn btn-block btn-login" onClick={() => handleOnclick()}  ><span className={isLoader ? ' spinner-border spinner-border-sm' : ''}></span> Entrar</button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 form-group">
                        <a href="/request/reset-pass" >Esqueci minha senha</a>
                    </div>
                </div>
            </div>
        </>
    )
}
